import { styled } from '@clickcease/cc-client-components-lib'

export const InvoicesRowsStyled = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  color: '$mainTextColor',
})

export const InvoicesNoResultsStyled = styled('div', {
  color: '$mainTextColor',
  textAlign: 'center',
  paddingTop: '$16',
})
